/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable */
import { UserContext } from '@/contexts/UserContext';
import useAuthorization from '@/hooks/useAuthorization';
import { EnterpriseMap } from '@/pages/Users/Users';
import { useAuth0 } from '@auth0/auth0-react';
import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import captionsIcon from '../../assets/images/menu-captions.svg';
import menuOpenIcon from '../../assets/images/bars-solid.svg';
import integrationsIcon from '../../assets/images/Integrations.svg';
import brandKitIcon from '../../assets/images/menu-brand-kit.svg';
import projectLibraryIcon from '../../assets/images/menu-project-library.svg';
import runsheetIcon from '../../assets/icons/runsheet.svg';
import streamKeyIcon from '../../assets/images/menu-stream-key.svg';
import menuCloseIcon from '../../assets/images/menu_open.svg';
import logoImage from '../../assets/images/Logo_Main Color.svg';
import logoOnly from '../../assets/images/only-logo.svg';
import {
  BRAND_KIT_URL,
  EVENTS_URL,
  INTEGRATIONS_URL,
  ORG_USERS_URL,
  PROJECTS_URL,
  RUNSHEETS_URL,
  STREAM_KEYS_URL,
  USERS_URL,
  CAPTIONS_URL,
} from '../../routePaths';
import LogoutIcon from '../Icons/LogoutIcon';
import styles from './Sidebar.module.scss';

interface SidebarProps {
  toggleSidebar(): void;
  isOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ toggleSidebar, isOpen }) => {
  const { logout, user } = useAuth0();
  const { userState } = useContext(UserContext);
  const { hasRole } = useAuthorization();
  const email = user?.email;

  const beforeAtSign = email?.substr(0, email.indexOf('@') + 1);
  const afterAtSign = email?.substr(email.indexOf('@') + 1);

  const iconKey = isOpen ? 'menuCloseIcon' : 'menuOpenIcon';

  return (
    <aside className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
      <div>
        <div className={isOpen ? styles.sidebarHeaderOpen : styles.sidebarHeaderClosed}>
          <Link to="/" className={styles.logo}>
            <img
              src={isOpen ? logoImage : logoOnly}
              alt="logo"
              className={isOpen ? styles.logoImage : styles.logoOnly}
            />
          </Link>
          <img
            key={iconKey}
            src={isOpen ? menuCloseIcon : menuOpenIcon}
            className={`${styles.menuIconButton}`}
            alt={isOpen ? 'menu open' : 'menu close'}
            onClick={toggleSidebar}
          />
        </div>
      </div>
      <div className={styles.profileInfo}>
        <div className={styles.profileInfoImg}>
          {/* <img
            src="https://www.pngitem.com/pimgs/m/150-1503945_transparent-user-png-default-user-image-png-png.png"
            alt="profile"
          /> */}
          {EnterpriseMap[`${userState?.role}`] ? EnterpriseMap[`${userState?.role}`] : 'Loading...'}
        </div>
        <div className={styles.profileInfoTexts}>
          <div className={styles.profileInfoEmail}>
            <button
              className={styles.logout}
              onClick={() =>
                logout({
                  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
                  returnTo: window.location.origin,
                })
              }
            >
              <div className={isOpen ? styles.email : styles.emailClosed}>
                <p>{beforeAtSign}</p>
                <p>{afterAtSign}</p>
              </div>
              <LogoutIcon
                className={`${styles.logoutIcon} ${isOpen ? '' : styles.logoutIconClosed}`}
              />
            </button>
          </div>
        </div>
      </div>
      <div className={styles.listWrapper}>
        <div className={styles.list}>
          <NavLink to={PROJECTS_URL} className={`${styles.item} ${isOpen ? '' : styles.centered}`}>
            <img src={projectLibraryIcon} alt="project library" />
            {isOpen && <span>Projects Library</span>}
          </NavLink>
          {/* Speaker-role (user) accounts only see Projects Library — the rest
              of the app is editor-only surface. Gate on "role is loaded AND
              not 'user'" so the editor tabs don't briefly flash in during
              login while the role is still resolving. */}
          {!!userState?.role && userState.role !== 'user' && (
            <>
              <NavLink
                to={BRAND_KIT_URL}
                className={`${styles.item} ${isOpen ? '' : styles.centered}`}
              >
                <img src={brandKitIcon} alt="brand kit" />
                {isOpen && <span>Brand Kit</span>}
              </NavLink>
              <NavLink
                to={CAPTIONS_URL}
                className={`${styles.item} ${isOpen ? '' : styles.centered}`}
              >
                <img src={captionsIcon} alt="captions" />
                {isOpen && <span>Captions</span>}
              </NavLink>
              <NavLink
                to={STREAM_KEYS_URL}
                className={`${styles.item} ${isOpen ? '' : styles.centered}`}
              >
                <img src={streamKeyIcon} alt="stream keys" />
                {isOpen && <span>Stream Keys</span>}
              </NavLink>
              <NavLink
                to={RUNSHEETS_URL}
                className={`${styles.item} ${isOpen ? '' : styles.centered}`}
              >
                <img src={runsheetIcon} alt="runsheets" />
                {isOpen && <span>Runsheets</span>}
              </NavLink>
              {!hasRole(['standard']) && (
                <NavLink
                  to={INTEGRATIONS_URL}
                  className={`${styles.item} ${isOpen ? '' : styles.centered}`}
                >
                  <img src={integrationsIcon} alt="integrations" />
                  {isOpen && <span>Integrations</span>}
                </NavLink>
              )}
              {hasRole(['admin', 'super_admin']) && (
                <>
                  <NavLink
                    to={ORG_USERS_URL}
                    className={`${styles.item} ${isOpen ? '' : styles.centered}`}
                  >
                    <img src={projectLibraryIcon} alt="organization users" />
                    {isOpen && <span>Organization Users</span>}
                  </NavLink>
                  <NavLink
                    to={EVENTS_URL}
                    className={`${styles.item} ${isOpen ? '' : styles.centered}`}
                  >
                    <img src={brandKitIcon} alt="events" />
                    {isOpen && <span>Events</span>}
                  </NavLink>
                </>
              )}
              {hasRole('super_admin') && (
                <NavLink
                  to={USERS_URL}
                  className={`${styles.item} ${isOpen ? '' : styles.centered}`}
                >
                  <img src={projectLibraryIcon} alt="users manage" />
                  {isOpen && <span>Manage Users (Legacy)</span>}
                </NavLink>
              )}
            </>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
